<template>
    <h3>欢迎使用issuebye网站</h3>
    <el-carousel :interval="4000" type="card" height="300px">
    <el-carousel-item v-for="item in imgList" :key="item.id">
                     <img :src="item.idView" class="image">
    </el-carousel-item>
  </el-carousel>
  <el-tabs type="border-card">
  <el-tab-pane label="云平台使用说明">
 <p>&nbsp;&nbsp;Issuebye.com 是由上海指北电脑有限公司开发的一款问题记录、解决和跟踪云平台，可以帮助您构建解决处理问题的知识库，也可以使用该云平台中的已有的知识库。</p>
<p> &nbsp;&nbsp;&nbsp;&nbsp;您可以双击该图标或使用 www.issuebye.com 进入该平台为您设置的账号。
<br>如需更多账号或者免费期后对账号续费，可以由贵公司管理员向上海指北有限公司销售人员联系，邮件：<b>sales@shcompass.com</b>
<br>在页面有上角点击新增问题，在弹出的页面选择公司，在标题栏输入问题。
类型中选择问题类型，如无类型可选可以在新增类型中进行添加。
在内容中详细描述问题的内容，设置问题的优先级，优先级越高问题排列靠前，然后点击确定，主页面添加一条刚刚我们新增的记录。
双击问题，屏幕右边弹出的新窗口会显示问题详情。问题内容可以根据问题的进展进行增加。在解决方案中填入问题处理的状态步骤，可以根据问题处理的节点填写。
同时Issuebye.com云平台中还为您提供了共享文件和知识库使用。
如果您需要详细的操作手册，可以给Service@shcompass.com 发送请求邮件，我们的服务人员会发送最新的手册给您。</p>

<p>&nbsp;&nbsp;Issuebye.com is an issue recording, solving and tracking cloud platform developed by Shanghai Compass Computer Co., Ltd., which can help you build up own knowledge base, and also its existing knowledge base can be utilized as well.
you can log in to this cloud platform system by double clicking the icon on the desktop or login www.issuebye.com.
If you need more accounts or after free of charge period, the administrator of your company can contact the sales of Shanghai Compass Computer Co., Ltd. by email: sales@shcompass.com.
Click on 'Add Issue' in the top corner of the page, select the company on the pop-up page, and enter the title of issue in the title bar.
Select the type of issue in the Type selection. If there is no type available, you can add them in the New Type session.
Describe the content of the issue in detail in the content, set the priority, prioritize the higher the priority, and then click OK to add an issue that we just added to the main page.
Double clicking on the issue, a new session on the right will display the issue details. The content of the issue can be added according to the progress of the issue solving. Fill in the statuses of issue handling in according to the nodes of issue handling.
At the same time, this Issue cloud platform also provides you with existing shared files and knowledge base.
If you need detailed instruction, you can email: service@shcompass.com to acquire the latest version.</p>
 </el-tab-pane>

  <!-- <el-tab-pane label="问题专家">
    专家群
 </el-tab-pane> -->

  <el-tab-pane label="开发设计">
    <el-collapse v-model="activeName" accordion>
  <el-collapse-item title="团队宗旨" name="1">
    <p class="mt20 cn_line">
        issuebye以知识创新基因吸引了来自国内业界精英，目前团队成员年轻朝气、充满活力，热爱新事物，勇于接受新挑战，团队成员有信心和决心，要用人人共享的理念在知识共享的浪潮中乘风破浪，要为行业工作者提供高效便捷的咨询服务。
      </p>
  </el-collapse-item>
  <el-collapse-item title="开发理念" name="2">
    <p>理念是理性的观念，是普遍真理，是做事的指导思想。</p>
    <p>沟通、简单、灵活，三者相互作用不可分割。</p>
  </el-collapse-item>
  <el-collapse-item title="设计原则" name="3">
    <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等；</div>
    <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
    <div>简化流程：设计简洁直观的操作流程；</div>
    <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
    <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
    <p></p>
  </el-collapse-item>
  <el-collapse-item title="可控 " name="4">
    <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
    <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
  </el-collapse-item>
 </el-collapse>
  </el-tab-pane>

  <el-tab-pane label="联系我们">
    <div class="text-box">
    <div class="text-content" id="text-content">
      <h1 class="title">联系我们</h1>
      <p class="mt20 cn_line">
        &nbsp;&nbsp;&nbsp; 如果您有任何意见或建议，欢迎通过邮件或电话联系我们。同时，欢迎您到我们公司参观或走访，来访前请先与我们的客服人员联系，我们将安排工作人员接见您的到来，感谢您对issuebye的信任和支持！
      </p>
<el-row>
    <el-col :span="8">
      <div class="mt20 cn_line fl" style="width:50%;height:150px;">
        <span
          style="line-height:34px;font-family:Microsoft YaHei;color:#0aaae1;font-size:24px;"
          >工作时间</span
        ><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;客服热线: 400-000-0000<br />
        <span style="padding-left:20px;font-size:12px;color:#888;"
          >（上午 8:30--12：00 下午 13：00--17：30）</span
        ><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;意见、建议反馈邮箱：issuebye@shcompass.com
      </div>
    </el-col>
    <el-col :span="8">
      <div class="mt20 cn_line fl" style="width:50%;height:150px;">
        <span
          style="line-height:34px;font-family:Microsoft YaHei;color:#0aaae1;font-size:24px;"
          >商务合作</span
        ><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;负责人：徐先生<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：400-000-0000<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电子邮箱：sales@shcompass.com
      </div>
    </el-col>
    <el-col :span="8">
      <div class="mt20 cn_line fl" style="width:50%;height:150px;">
        <span
          style="line-height:34px;font-family:Microsoft YaHei;color:#0aaae1;font-size:24px;"
          >客户服务</span
        ><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;负责人：徐先生<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：15350183115<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电子邮箱：Oscar.xu@shcompass.com
      </div>
    </el-col>
</el-row>
      <p></p>
    </div>
  </div>
  </el-tab-pane>
</el-tabs>
</template>

<script>
  export default {
    data() {
      return {
        itemcard:[
          'https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg',
          'https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg',
          'https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg',
          'https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg',
        ],
        imgList: [
                {id:0,idView:'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg'},
                {id:1,idView:'https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/11/27/issue_view_01.png'},
                {id:2,idView:'https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/11/27/issue_view_02.png'},
                {id:3,idView:'https://srb-data.oss-cn-beijing.aliyuncs.com/issue/2023/11/27/微信图片_20231127114222.jpg'}            
            ],
        activeName: '1',
      }
    }
  }
</script>

<style>
  .el-carousel__item h3 {
    color: #476951;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99bfa1;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3e6d5;
  }

  p {
    text-align: left;
  }
 
</style>
